import React, { useState } from "react";
import { useForm, ValidationError } from '@formspree/react';
import { courses } from "../Data/courses";

const ContactForm = () => {
  const [state, handleSubmit] = useForm("mzdaaaod");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    whatsapp: "",
    country: "",
    course: "",
    message: "",
  });
  const [showNotification, setShowNotification] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    
    // Show notification
    setShowNotification(true);
    
    // Hide notification after 2.5 seconds
    setTimeout(() => {
      setShowNotification(false);
    }, 2500);
    
    await handleSubmit(e);
    
    if (state.succeeded) {
      const selectedCourse = courses.find(c => c.title === formData.course);
      const whatsappMessage = encodeURIComponent(
        `Hi, my name is ${formData.name}. I'm interested in ${formData.course} ($${selectedCourse?.price}/month). ${formData.message}`
      );
      const whatsappLink = `https://wa.me/${formData.whatsapp}?text=${whatsappMessage}`;
      window.open(whatsappLink, "_blank");
      
      setFormData({ 
        name: "", 
        email: "",
        whatsapp: "", 
        country: "",
        course: "",
        message: ""
      });
    }
  };

  if (state.succeeded) {
    return (
      <div className="w-full flex justify-center items-center">
        <div className="w-full max-w-4xl bg-white/90 backdrop-blur-sm rounded-lg border border-gray-200 shadow-sm p-8 text-center">
          <p className="text-green-600 text-lg">Thanks for joining! We'll contact you soon.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center items-center relative">
  
      {showNotification && (
        <div className="fixed top-5 left-1/2 transform -translate-x-1/2 z-50 animate-fade-in-down">
          <div className="bg-green-700 text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3">
            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="font-medium">Sending your form...</span>
          </div>
        </div>
      )}

      <div className="w-full max-w-4xl bg-white/90 backdrop-blur-sm rounded-lg border border-gray-200 shadow-sm p-4">
        <div className="text-center mb-4">
          <h3 className="font-semibold text-green-800 text-base">Get Free Trial</h3>
          <p className="text-gray-500 text-xs">Start learning today</p>
        </div>

        <form onSubmit={onSubmit} className="flex flex-col gap-3">
          <div className="flex flex-col md:flex-row gap-3">
            <div className="flex-1">
              <label htmlFor="name" className="text-sm text-green-800 font-medium">Full Name*</label>
              <input
                id="name"
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-1 focus:ring-green-800"
                placeholder="Your name"
              />
              <ValidationError prefix="Name" field="name" errors={state.errors} />
            </div>

            <div className="flex-1">
              <label htmlFor="email" className="text-sm text-green-800 font-medium">Email*</label>
              <input
                id="email"
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-1 focus:ring-green-800"
                placeholder="your@email.com"
              />
              <ValidationError prefix="Email" field="email" errors={state.errors} />
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-3">
            <div className="flex-1">
              <label htmlFor="whatsapp" className="text-sm text-green-800 font-medium">WhatsApp*</label>
              <input
                id="whatsapp"
                type="tel"
                name="whatsapp"
                required
                value={formData.whatsapp}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-1 focus:ring-green-800"
                placeholder="WhatsApp number"
              />
              <ValidationError prefix="WhatsApp" field="whatsapp" errors={state.errors} />
            </div>

            <div className="flex-1">
              <label htmlFor="country" className="text-sm text-green-800 font-medium">Country*</label>
              <select
                id="country"
                name="country"
                required
                value={formData.country}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-1 focus:ring-green-800"
              >
                <option value="">Select country</option>
                <option value="US">United States</option>
                <option value="UK">United Kingdom</option>
                <option value="CA">Canada</option>
                <option value="AU">Australia</option>
                <option value="PK">Pakistan</option>
                <option value="SA">Saudi Arabia</option>
              </select>
              <ValidationError prefix="Country" field="country" errors={state.errors} />
            </div>
          </div>

          <div>
            <label htmlFor="course" className="text-sm text-green-800 font-medium">Select Course*</label>
            <select
              id="course"
              name="course"
              required
              value={formData.course}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-1 focus:ring-green-800"
            >
              <option value="">Choose a course</option>
              {courses.map((course, index) => (
                <option key={index} value={course.title}>
                  {course.title} - {' '} ${course.price}/month
                </option>
              ))}
            </select>
            <ValidationError prefix="Course" field="course" errors={state.errors} />
          </div>

          <div>
            <label htmlFor="message" className="text-sm text-green-800 font-medium">Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm resize-none max-h-28 overflow-y-auto focus:ring-1 focus:ring-green-800"
              placeholder="Your message (optional)"
            />
            <ValidationError prefix="Message" field="message" errors={state.errors} />
          </div>

          <div className="flex gap-3 w-full">
            <button
              type="submit"
              disabled={state.submitting}
              className="flex-1 bg-green-700 hover:bg-green-800 text-white text-sm font-medium py-2.5 rounded-md transition disabled:opacity-50"
            >
              {state.submitting ? "Sending..." : "Submit"}
            </button>

            
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;